import {useState, useEffect} from 'react';

export default (url) => {
  const [size, setSize] = useState([null, null]);

  useEffect(() => {
    if (!url) return;
    const img = document.createElement('img');
    img.addEventListener('load', (e) => {
      const {naturalHeight, naturalWidth} = e.target;
      setSize([naturalWidth, naturalHeight]);
    });
    img.src = url;
  }, [url]);

  return size;
};
